import React, { useState } from 'react';
import './BookDemo.css';

const BookDemoForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    organization: '',
    category: '',
    categoryOther: '',
    challenge: '',
    challengeOther: ''
  });

  const [loading, setLoading] = useState(false); // Loader state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loader

    try {
      const response = await fetch('https://skillshap.com/book-demo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        window.location.href = 'https://calendly.com/abdul-sabir-skillshap/30min?month=2025-07';
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error connecting to server.");
    } finally {
      setLoading(false); // Hide loader after process
    }
  };

  return (
    <>
      <br />
      <br />
      <br />
      <div className="booking-container">
        {/* Left Side */}
        <div className="booking-left">
          <div className="left-content">
            <h1 className="left-heading">
              Turn Struggles Into Success – <br />5X Faster Placements Start Here 🚀
            </h1>
            <p className="left-marketing">
              Whether you’re placing students, coaching job seekers, or hiring talent,
              <span className='highlight'> SkillsHap bridges the gap between skill and success. <br /></span>
              <strong>Join 50+ teams</strong> using our 
              <span className="highlight"> AI-powered, expert-backed platform</span> to drive faster, structured placements.
            </p>
          </div>
        </div>

        {/* Right Side Form Card */}
        <div className="booking-right">
          <form onSubmit={handleSubmit} className="form">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              required
              value={formData.name}
              onChange={handleChange}
            />

            <input
              type="email"
              name="email"
              placeholder="Work Email ID"
              required
              value={formData.email}
              onChange={handleChange}
            />

            <input
              type="tel"
              name="number"
              placeholder="Phone / WhatsApp Number"
              required
              value={formData.number}
              onChange={handleChange}
            />

            <input
              type="text"
              name="organization"
              placeholder="Organization / Company"
              required
              value={formData.organization}
              onChange={handleChange}
            />

            {/* Category Dropdown */}
            <select
              name="category"
              value={formData.category}
              required
              onChange={handleChange}
            >
              <option value="">Which category best describes you?</option>
              <option value="College"> College or University</option>
              <option value="EdTech"> Training Institute / EdTech</option>
              <option value="HR"> HR / Recruiter</option>
              <option value="Job Seeker"> Job Seeker</option>
              <option value="Coach"> Coaches/ Mentors/ Trainers</option>
              <option value="Other"> Other</option>
            </select>

            {formData.category === 'Other' && (
              <input
                type="text"
                name="categoryOther"
                placeholder="Please specify other category"
                value={formData.categoryOther}
                onChange={handleChange}
              />
            )}

            {/* Challenge Dropdown */}
            <select
              name="challenge"
              value={formData.challenge}
              required
              onChange={handleChange}
            >
              <option value="">What's Your Biggest challenge?</option>
              <option value="Placement Issues">Struggling to place students / job seekers</option>
              <option value="Resume Issues">Lack of resume/clarity/confidence</option>
              <option value="Interview Prep">Interview prep is weak</option>
              <option value="Interview Prep"> Struggling with Client Partnership</option>
              <option value="Other">Other</option>
            </select>

            {formData.challenge === 'Other' && (
              <input
                type="text"
                name="challengeOther"
                placeholder="Please describe your challenge"
                value={formData.challengeOther}
                onChange={handleChange}
              />
            )}

            <button type="submit">Book a Slot</button>
          </form>
        </div>
      </div>

      {/* Loader Overlay */}
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
    </>
  );
};

export default BookDemoForm;
